<template>
  <!--角色管理 -->
  <div>
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':1,'value':'待审核'},{'key':2,'value':'审核通过'},{'key':3,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>留言类型：</div>
          <el-select v-model="messageType" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择留言类型">
            <el-option
                v-for="item in [{'key':1,'value':'资讯'},{'key':2,'value':'其他'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">
            批量审核
          </el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small"
                     type="danger">批量删除
          </el-button>
        </div>
        <el-table
            size="small"
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="留言内容" width="600" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.message}}
                </template>
                <span style="width:570px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.message }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="留言类型" align="center" width="150">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <div>{{ scope.row.message_type === 1 ? '资讯' : '其他' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="留言时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.create_date }}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="warning" size="small" effect="dark" v-if="scope.row.examine_status === '0' || scope.row.examine_status === '1'">待审核</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else-if="scope.row.examine_status === '2'">审核通过
                </el-tag>
                <el-tag type="danger" size="small" effect="dark" v-else-if="scope.row.examine_status === '3'">审核未通过
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === '0' || scope.row.examine_status === '1'" size="small"
                         type="success">审核
              </el-button>
              <el-button @click="deleteBtn(scope.row)" size="small" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>
    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px"
                     clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':2,'value':'审核通过'},{'key':3,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      messageType: null,
      tableData: [],
      totalElements: 0,//数据总数
      multipleSelection: [],
      auditBatchList: [],
      deleteDialogState: false,
      deleteItem: {},
      simpleDelete: false,//是单个删除还是多个删除
      auditDialogState: false,
      auditRuleForm: {
        examineStatus: null
      },
      auditRules: {
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit: false,
      auditItem: {},
    };
  },
  methods: {
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getDynamicList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.messageType = null
      this.getDynamicList()
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteItem = row
      this.deleteDialogState = true
    },
    auditBtn(row) {
      this.simpleAudit = true
      this.auditItem = row
      this.auditRuleForm.examineStatus = 2
      this.auditDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    auditBatchBtn() {
      this.simpleAudit = false
      this.auditRuleForm.examineStatus = 2
      this.auditDialogState = true
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    auditCancel() {
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit) {
            let newsIds = []
            let otherIds = []
            if (this.auditItem.message_type === 1) {
              newsIds.push(this.auditItem.id)
            } else {
              otherIds.push(this.auditItem.id)
            }
            this.postAxios("/message/updMessageByIds", {
              examineStatus: this.auditRuleForm.examineStatus,
              newsMessageIds: newsIds,
              otherMessageIds: otherIds
            }).then(res => {
              if (res.success) {
                this.$message.success(res.message)
                this.auditItem = {}
                this.auditDialogState = false
                this.getDynamicList()
              }
            })
          } else {
            let newsIds = []
            let otherIds = []
            if (this.auditItem.message_type === 1) {
              newsIds.push(this.auditItem.id)
            } else {
              otherIds.push(this.auditItem.id)
            }
            this.auditBatchList.forEach((item) => {
              if (item.message_type === 1) {
                newsIds.push(item.id)
              } else {
                otherIds.push(item.id)
              }
            })
            this.postAxios("/message/updMessageByIds", {
              examineStatus: this.auditRuleForm.examineStatus,
              newsMessageIds: newsIds,
              otherMessageIds: otherIds
            }).then(res => {
              if (res.success) {
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getDynamicList()
              }
            })
          }
        }
      });
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        let newsIds = []
        let otherIds = []
        if (this.deleteItem) {
          if (this.deleteItem.message_type === 1) {
            newsIds.push(this.deleteItem.id)
          } else {
            otherIds.push(this.deleteItem.id)
          }
        }
        //单个删除
        this.postAxios("/message/delMessageByIds", {
          newsMessageIds: newsIds,
          otherMessageIds: otherIds
        }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteItem = {}
            this.deleteDialogState = false
            this.getDynamicList()
          }
        })
      } else {
        //多个删除
        let newsIds = []
        let otherIds = []
        this.multipleSelection.forEach((item) => {
          if (item.message_type === 1) {
            newsIds.push(item.id)
          } else {
            otherIds.push(item.id)
          }
        })
        this.postAxios("/message/delMessageByIds", {
          newsMessageIds: newsIds,
          otherMessageIds: otherIds
        }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteItem = {}
            this.deleteDialogState = false
            this.getDynamicList()
          }
        })
      }
    },
    //用户列表
    getDynamicList() {
      this.postAxios("/message/getAllMessage", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          examineStatus: this.examineStatus ? this.examineStatus : null,
          messageType: this.messageType ? this.messageType : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item) => {
            item.create_date_list = item.create_date.split(' ')
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      console.log(this.multipleSelection, 999)
      if (this.multipleSelection && this.multipleSelection.length) {
        this.multipleSelection.forEach((item) => {
          if (item.examine_status === '0' || item.examine_status === '1') {
            this.auditBatchList.push(item)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDynamicList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getDynamicList()
    }
  },
  created() {
    this.getDynamicList(); //用户的列表
  }
};
</script>
<style>
</style>
